import { useSelector } from "react-redux";
import { PackageIcon } from "@app/design-system/icons";
import { CustomerIdentityRow } from "@app/features/shared/CustomerIdentityRow";
import { RootState } from "@app/store";
import { t } from "@app/utils/translation";
import { TrackingHeaderProps } from "./TrackingHeader.types";
import styles from "./TrackingHeader.module.css";

/**
 * The Home page's sticky header — company branding + order code on top,
 * customer identity below. Home-page-only (it sits above the map), so it
 * lives under `features/home/components` rather than `features/shared` or
 * `shared/layout`; if a second page ever needs this exact header, that's the
 * signal to promote it, not before (see architecture doc §11).
 */
export const TrackingHeader = ({ logoUrl, orderCode, customerName, isDropoffTracking = false }: TrackingHeaderProps) => {
  const language = useSelector((state: RootState) => state.setting.language);

  return (
    <header className={styles.header}>
      <div className={styles.topRow}>
        <img className={styles.logo} src={logoUrl} alt={t("CompanyLogo", language)} />
        {isDropoffTracking ? null : (
          <span className={styles.orderCode}>
            <PackageIcon size={20} />
            {orderCode}
          </span>
        )}
      </div>

      <div className={styles.divider} />

      <CustomerIdentityRow name={customerName} />
    </header>
  );
};
